import { CurrencyPipe } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { GetTransactionsType } from 'src/app/shared/enums/get-transactions-type';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { Transaccion } from '../../interfaces/transaccion.interface';
import { TransaccionService } from '../../services/transaccion.service';
import { WorkingAccountService } from '../../services/working-account.service';
import { DetalleCajeroComponent } from '../detalle-cajero/detalle-cajero.component';
@Component({
  selector: 'app-status-cajero-fiat',
  templateUrl: './status-cajero-fiat.component.html',
  styleUrls: ['./status-cajero-fiat.component.sass'],
})
export class StatusCajeroFiatComponent implements OnDestroy {
  statusCajero: any[] = [];
  countryCode = ['VE'];
  transacciones: Transaccion[] = [];
  expandedCardId: number | null = null;

  displayedColumns: string[] = [
    'cajero',
    'banco',
    'moneda',
    'balanceSistema',
    'balance',
    'total',
    'necesarioOB',
    'necesarioMB',
  ];
  columns = [
    {
      columnDef: 'cajero',
      header: 'Cajero',
      cell: (element: any) =>
        `${element.cuenta.nombre} ${element.cuenta.apellidos}`,
      clickable: true,
    },
    {
      columnDef: 'banco',
      header: 'Banco',
      cell: (element: any) => `${element.cuenta.banco.nombre}`,
    },
    {
      columnDef: 'moneda',
      header: 'Moneda',
      cell: (element: any) => this.getCurrency(element.cuenta.banco.codigoPais),
    },
    {
      columnDef: 'balanceSistema',
      header: 'Balance en sistema',
      cell: (element: any) =>
        `${this.currencyPipe.transform(element.total, '$')}`,
    },
    {
      columnDef: 'balance',
      header: 'Balance restante en el sistema',
      cell: (element: any) =>
        `${this.currencyPipe.transform(
          element.total - (element.necesarioOb + element.necesarioMb),
          '$',
        )}`,
    },
    {
      columnDef: 'total',
      header: 'Total',
      cell: (element: any) =>
        `${this.currencyPipe.transform(
          element.necesarioOb + element.necesarioMb,
          '$',
        )}`,
    },
    {
      columnDef: 'fiatOB',
      header: 'Fiat OB',
      cell: (element: any) =>
        `${this.currencyPipe.transform(element.fiatOb, '$')}`,
    },
    {
      columnDef: 'necesarioOB',
      header: 'Necesario OB',
      cell: (element: any) =>
        `${this.currencyPipe.transform(element.necesarioOb, '$')}`,
    },
    {
      columnDef: 'necesarioMB',
      header: 'Necesario MB',
      cell: (element: any) =>
        `${this.currencyPipe.transform(element.necesarioMb, '$')}`,
    },
  ];
  dataSource: MatTableDataSource<any> | undefined;

  bancos: string[] = [];
  selectedBanco: string = '';
  selectedMoneda: string = 'VES';

  private refreshInterval: any;

  constructor(
    private workingAccountService: WorkingAccountService,
    private spinner: SpinnerService,
    private currencyPipe: CurrencyPipe,
    private transactionService: TransaccionService,
    private dialog: MatDialog,
  ) {
    this.loadData();
    this.startAutoRefresh();
  }

  ngOnDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  startAutoRefresh() {
    this.refreshInterval = setInterval(() => {
      this.loadData();
    }, 180000);
  }

  toggleCard(id: number): void {
    this.expandedCardId = this.expandedCardId === id ? null : id;
  }

  onCajeroClick(element: any) {
    this.dialog.open(DetalleCajeroComponent, {
      width: '95vw',
      maxWidth: '1400px',
      height: '90vh',
      data: {
        cuenta_trabajo_id: element.cuenta.cuenta_trabajo_id,
        transacciones: this.transacciones,
        statusCajero: this.statusCajero,
        countryCode: this.countryCode,
      },
    });
  }
  async loadData() {
    const ref = this.spinner.start();

    const currentFilters = {
      banco: this.selectedBanco,
    };

    this.statusCajero = await this.workingAccountService.getStatusCajero(
      this.countryCode,
    );
    this.extractFilters();
    const bankType = false ? 'BINANCE' : undefined;
    const transaccionesResult = await this.transactionService.getAllTransactions(
      GetTransactionsType.ASSIGNED,
      bankType,
    );
    this.transacciones = Array.isArray(transaccionesResult)
      ? transaccionesResult
      : (transaccionesResult as any)?.query ?? [];
    await this.calculateNecesarioValues();
    this.dataSource = new MatTableDataSource(this.statusCajero);

    if (currentFilters.banco) {
      this.selectedBanco = currentFilters.banco;
      this.applyFilters();
    }

    this.spinner.stop(ref);
  }

  async calculateNecesarioValues() {
    this.statusCajero.forEach((cajero) => {
      cajero.necesarioMb = 0;
      cajero.necesarioOb = 0;
    });

    this.transacciones.forEach((transaccion) => {
      if (transaccion.cuentaTrabajo && transaccion.cuentaBeneficiario) {
        const cajero = this.statusCajero.find(
          (c) => c.id === transaccion.cuentaTrabajo?.cuenta_trabajo_id,
        );

        if (cajero) {
          const bancoBeneficiario = transaccion.cuentaBeneficiario.bancoID;
          const bancoTrabajo = transaccion.cuentaTrabajo.bancoID;

          if (bancoBeneficiario === bancoTrabajo) {
            cajero.necesarioMb += transaccion.totalMonedaDestino;
          } else {
            cajero.necesarioOb += transaccion.totalMonedaDestino;
          }
        }
      }
    });

    if (this.dataSource) {
      this.dataSource.data = [...this.statusCajero];
    }
  }

  getCurrency(codigoPais: string): string {
    switch (codigoPais) {
      case 'VE':
        return 'VES';
      case 'US':
        return 'USD';
      case 'CL':
        return 'CLP';
      default:
        return codigoPais;
    }
  }

  extractFilters() {
    const bancosSet = new Set<string>();

    this.statusCajero.forEach((item) => {
      if (item.cuenta?.banco?.nombre) {
        bancosSet.add(item.cuenta.banco.nombre);
      }
    });

    this.bancos = Array.from(bancosSet).sort();
  }

  applyFilters() {
    if (!this.dataSource) return;

    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const filters = JSON.parse(filter);
      const bancoMatch =
        !filters.banco || data.cuenta?.banco?.nombre === filters.banco;
      return bancoMatch;
    };

    this.dataSource.filter = JSON.stringify({
      banco: this.selectedBanco,
    });
  }

  clearFilters() {
    this.selectedBanco = '';
    this.applyFilters();
  }

  getBlinkingClass(element: any): string {
    const columnTotal =
      element.necesarioOb + element.fiatOb + element.necesarioMb;
    if (columnTotal === 0) {
      return '';
    }

    const total =
      element.total -
      (element.necesarioOb + element.fiatOb + element.necesarioMb);

    const umbralAmarillo = 20000;

    if (total < 1) {
      return 'blinking-text';
    } else if (total < umbralAmarillo) {
      return 'blinking-text2';
    }
    return '';
  }
}
